import React, { useEffect, useState } from 'react'
import Api from '../../services/Api'
import { IonAvatar, IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonChip, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonPage, IonRow, IonSpinner, IonText, IonTitle, IonToolbar, isPlatform, useIonViewDidEnter } from '@ionic/react'
import { goToPage } from '../../helpers/app_actions'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/reducers'
import { arrowForward, open, reload, ribbon, trophy } from 'ionicons/icons'
import { SafetyPadding } from '../../components/SafetyPadding'
import Pie from '../StepCounter/Circle/Circle'
import { StepChallengeInterface } from '../StepCounter/StepChallenges'
import dayjs from 'dayjs'
import { checkStepcounterEnabled, doEnableSteps, enabledInt, openSettings, requestStepPermission, updateStepData } from '../../helpers/step_helper'

interface StatisticInterface {
  total_steps: number
  booked_walks: number
  created_walks: number              
  total_walks: number
  steps_today: number
  counter_enabled: Boolean
  counter_goal: number   
}

const Statistic = () => {
  const api = Api.getInstance()
  const me = useSelector((state: RootState) => state.logIn.user.person)
  const [loading, setLoading] = useState(false)
  const [challenge, setChallenge] = useState<Array<StepChallengeInterface>>([])
  const [statistic, setStatistic] = useState<StatisticInterface>({
    total_steps: 0,
    booked_walks: 0,
    created_walks: 0,           
    total_walks: 0,
    steps_today: 0,
    counter_enabled: false,
    counter_goal: 0
  })
  const [latestChal, setLatestChal] = useState<StepChallengeInterface>({
    id: 0,
    name: '',
    start: '',
    end: '',
    routeName: '',
    routeDistance: 0,
    stepsDone: 0,
    distanceDone: 0,
    persons: []
  })

  useIonViewDidEnter(() => {
   getStats()
  })

  const getStats = () => {
    checkStepcounterEnabled().then(res => {
      if(res === true) {
        // doEnableSteps("stepsStart")          
        updateStepData().then(() => {
          if(loading === true) {
            setLoading(false)
          }
        }).catch(e => {
        })    
      } else {
        if(isPlatform('android')) {
          requestStepPermission().then(res => {
            updateStepData().then((res) => {
              if(loading === true) {
                setLoading(false)
              }
            })
          }).catch(e => {
            enabledInt(false)
          })
        } else {
          // handle ios
          updateStepData().then((res) => {
            if(loading === true) {
              setLoading(false)
            }
          })
        }
      }
    }).then(() => {   
      getData()
    }).catch(e => {
      doEnableSteps("stepsStop")
      enabledInt(false)
      getData()
    })
  }

  const getData = () => {
    api.get('/person/statistic').then(res => {
      res.json().then(data => {
        if(data.status === 'ok') {
          setStatistic(data.data)
        }
      }).then(() => {
        api.get('pedometer/step_challenges').then(res => {
          res.json().then(data => {
            if(data.status === 'ok') {
              setChallenge(data.challenges.filter((v: any, i: any, a: any) => a.findIndex((v2: any) =>(v2.id === v.id)) === i))
              setLoading(true)
            }
          })
        }).catch(e => console.log("error*****",e))
      })
    })
  }

  useEffect(() => {
    const newArr = challenge.sort((a, b) => {
      return new Date(b.start).getTime() - new Date(a.start).getTime();
    })
    setLatestChal(newArr[0])
  }, [challenge])

  const percentageToGoal = () => {
    return (latestChal.distanceDone / latestChal.routeDistance) * 100
  }

  const checkIfActiveChallenge = () => {
    let challenge = <IonCard className="m-2">
      <IonCardHeader color="light" className="p-2">
        <IonCardTitle mode="md" ><b className="color_blue">{api.tr('active_challenge')}</b></IonCardTitle>
        <IonCardSubtitle mode="md" className="mt-2">{api.tr('no_active_challenge')}</IonCardSubtitle>
      </IonCardHeader>
      <IonCardContent></IonCardContent>
    </IonCard>

    if(latestChal && dayjs().isBetween(latestChal.start, latestChal.end)) {
      // console.log(latestChal)
      challenge = <IonCard className="m-2" onClick={() => goToPage('/walk/challenges/' + latestChal.id )}>
      <IonCardHeader color="light" className="p-2">
        <IonCardTitle mode="md" ><b className="color_blue">{api.tr('active_challenge')}</b></IonCardTitle>
        <IonCardSubtitle mode="md" className="mt-2">{latestChal.name} - {latestChal.start} - {latestChal.end}</IonCardSubtitle>
      </IonCardHeader>
      <IonCardContent>
        <IonGrid>
          <IonRow>
            <IonCol>
              <IonList>
                <IonItem>
                  <IonLabel>{api.tr('distance_done')}</IonLabel> {(latestChal.distanceDone/ 1000).toFixed(1)}  km
                </IonItem>
                <IonItem>
                  <IonLabel>{api.tr('route')}</IonLabel> {latestChal.routeName}
                </IonItem>
                <IonItem>
                  <IonLabel>{api.tr('active_persons')}</IonLabel> {latestChal.persons.length}
                </IonItem>
              </IonList>
            </IonCol>
            <IonCol className="flex justify-end">
              <Pie
                type="km"
                percentage={percentageToGoal()} 
                colour="hsl(224, 50%, 40%)" 
                steps={latestChal.distanceDone} 
                goal={latestChal.routeDistance}/>
            </IonCol>
          </IonRow>
          <IonRow className="mt-4">
            <IonCol className="flex justify-end items-center">
              <IonButton onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                goToPage('/walk/challenges/' + latestChal.id )}}>Gå till utmaningen</IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonCardContent>
    </IonCard>
    }

    return challenge
  }

  return (
    <IonPage className="cheap_desktop statisticPage">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton/>
          </IonButtons>
          <IonTitle>{api.tr('statistic')}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={() => getStats()} color="primary">
              <IonIcon icon={reload}/>
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      { loading ? 
      <IonContent>
        <IonList lines="none">
          <IonCard className='m-2'>
            <IonCardHeader color="light" className="p-2 flex">
              <IonAvatar>
                <img src={me.picture} alt=""/>
              </IonAvatar>
              <IonCardTitle mode="md" className="ml-2">
                {me.firstName}
              </IonCardTitle>
            </IonCardHeader>
            <IonCardContent className="p-2">
              <IonList>
              { statistic.counter_enabled ? 
                <IonItem>
                  <IonLabel color="darkblue"><b>{api.tr('total_steps')}</b></IonLabel>
                  {statistic.total_steps}
                </IonItem> 
              : null }
                <IonItem>
                  <IonLabel color="darkblue"><b>{api.tr('total_walks')}</b></IonLabel>
                  {statistic.total_walks}
                </IonItem>
                <IonItem>
                  <IonLabel color="darkblue"><b>{api.tr('booked_walks')}</b></IonLabel>
                  {statistic.booked_walks}
                </IonItem>
                <IonItem>
                  <IonLabel color="darkblue"><b>{api.tr('created_walks')}</b></IonLabel>
                  {statistic.created_walks}
                </IonItem>
              </IonList>
            </IonCardContent>
          </IonCard>
          <IonCard 
            className="p-2 m-2" 
            onClick={() => goToPage('/walk/stepcounter')}>
            <IonCardHeader className="flex justify-between p-2">
              <IonCardTitle mode="md">
                <b className="color_blue">{api.tr('today')}</b>
                {isPlatform('android') ?
                  <IonChip className="p-2 ml-2" color={statistic.counter_enabled ? 'primary' : 'medium'}>
                  { statistic.counter_enabled ?
                    api.tr('stepcounter_enabled')
                  :
                    api.tr('stepcounter_disabled')
                  }
                  </IonChip> 
                : null}
              </IonCardTitle>
              {/* { statistic.steps_today >= statistic.counter_goal ? 
                <IonIcon size='large' color="primary" icon={star}/>
              :
                <IonIcon size='large' color="medium" icon={starOutline}/>
              } */}
            </IonCardHeader>
            <IonCardContent>
              <IonGrid>
                <IonRow>
                  <IonCol className="flex flex-col items-center">
                    <h2 className='circle_large flex justify-center items-center background_smoke'>
                      {statistic.steps_today} 
                    </h2>
                    <IonText>{api.tr('steps')}</IonText>
                  </IonCol>
                  <IonCol className="flex flex-col items-center">
                    <h2 className='circle_large flex justify-center items-center background_smoke'>
                      {statistic.counter_goal}
                    </h2>
                    <IonText>{api.tr('goal')}</IonText>
                  </IonCol>
                </IonRow>
                { isPlatform('capacitor') ? 
                <IonRow className="flex justify-end mt-4">
                  <IonButton fill="clear" onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    if(statistic.counter_enabled || isPlatform('iphone')) {
                      goToPage('/walk/stepcounter')
                    } else {
                      openSettings()
                    }
                    }}>
                      {statistic.counter_enabled || isPlatform('iphone') ? api.tr('view_steps') : api.tr('activate_steps')}
                    <IonIcon icon={statistic.counter_enabled ? arrowForward : open }/>
                  </IonButton>
                </IonRow> : 
                <IonRow className="flex justify-end mt-4">
                  <IonButton 
                    fill="clear" 
                    onClick={(e) => {
                      e.stopPropagation()
                      e.preventDefault()
                      goToPage('/walk/stepcounter')
                    }}
                  >
                     {api.tr('view_steps')}
                    <IonIcon icon={statistic.counter_enabled ? arrowForward : open }/>
                  </IonButton>
                </IonRow>
                }
              </IonGrid>
            </IonCardContent>
          </IonCard>
          <IonCard className="m-2" onClick={() => goToPage('/walk/leaderboard')}>
            <IonCardHeader color="light" className="p-2">
              <IonRow>
                <IonCol size="1" className=" flex justify-center items-center">
                  <IonIcon icon={ribbon} size="large" color="teal"/>
                </IonCol>
                <IonCol size="7">
                  <IonCardTitle mode="md"><b className="color_blue">{api.tr('leaderboard')}</b></IonCardTitle>
                  <IonCardSubtitle mode="md" className="mt-2">{api.tr('leaderboard_info')}</IonCardSubtitle>
                </IonCol>
                <IonCol className="flex justify-end items-center">
                  <IonButton fill="clear" onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    goToPage('/walk/leaderboard')
                  }}> 
                    <IonIcon icon={arrowForward}/>
                  </IonButton>
                </IonCol>
              </IonRow>

            </IonCardHeader>
          </IonCard>

          { checkIfActiveChallenge() }

          <IonCard className="m-2" onClick={() => goToPage('/walk/challenges')} >
            <IonCardHeader color="light" className="p-2">
              <IonRow>
                <IonCol size="1" className=" flex justify-center items-center">
                  <IonIcon icon={trophy} size="large" color="teal"/>
                </IonCol>
                <IonCol>
                  <IonCardTitle mode="md" ><b className="color_blue">{api.tr('all_challenges')}</b></IonCardTitle>
                  <IonCardSubtitle mode="md" className="mt-2">{api.tr('view_challenge_history')}</IonCardSubtitle>
                </IonCol>
                <IonCol className="flex justify-end items-center">
                  <IonButton fill="clear" onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    goToPage('/walk/challenges')}}> 
                    <IonIcon icon={arrowForward}/>
                  </IonButton>
                </IonCol>
              </IonRow>

            </IonCardHeader>
            <IonCardContent>

            </IonCardContent>
          </IonCard>

        </IonList>
        <SafetyPadding/>
      </IonContent>
      : 
      <IonContent>
        <IonGrid>
          <IonRow className="p-4 flex justify-center items-center">
            <IonSpinner/>
          </IonRow>
        </IonGrid>
      </IonContent>
      }
    </IonPage>
  )
}

export default Statistic